import { Button, Image, Stack, Text } from '@mantine/core';
import logoMpa from '@/assets/logo-mpa.svg';
import styles from './SignInLanding.module.sass';

const LOGO_ALT = 'My Parish Office logo';

type SignInLandingProps = {
  title?: string;
  description?: string;
  signInLabel: string;
  onSignIn: () => void;
};

export const SignInLanding = ({ title, description, signInLabel, onSignIn }: SignInLandingProps) => {
  return (
    <main className={styles.root}>
      <Stack align="center" gap="md">
        <Image src={logoMpa} alt={LOGO_ALT} className={styles.logo} />
        {title ? (
          <Text size="lg" fw={500} ta="center">
            {title}
          </Text>
        ) : null}
        {description ? (
          <Text size="sm" c="dimmed" maw={400} ta="center">
            {description}
          </Text>
        ) : null}
        <Button type="button" onClick={onSignIn}>
          {signInLabel}
        </Button>
      </Stack>
    </main>
  );
};
